module.exports = __webpack_public_path__ + "img/person-ski-jumping.e839525e.svg";